export default "__VITE_ASSET__D1W9i4Nf__"